/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalCheckStatusSanction =
  typeof InternalCheckStatusSanction[keyof typeof InternalCheckStatusSanction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalCheckStatusSanction = {
  NO_MATCH: 'NO_MATCH',
  TRUE_MATCH: 'TRUE_MATCH',
  INCONCLUSIVE: 'INCONCLUSIVE',
} as const;
